export default __webpack_public_path__ + "static/media/welcome-dashboard-staff.0b564674.png";